import type { ComponentProps } from 'react';

import { cn } from '../cn';

/** Copied from ui/icons' DownCaretIcon, on currentColor. The stroke scales with
    the drawn size, so it stays a hairline at a chip's 10px and holds up larger. */
export const DownCaretIcon = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg
    viewBox='0 0 9 6'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden
    className={cn('w-2.5', className)}
    {...props}>
    <path d='M0.5 1L4.5 5L8.5 1' stroke='currentColor' strokeLinecap='round' vectorEffect='non-scaling-stroke' />
  </svg>
);
